import { registerComponent } from '@gig/magic-common';
import ExperimentVWOComponent from './experiment-vwo.vue.js';

var ExperimentVWO = registerComponent(ExperimentVWOComponent);

export { ExperimentVWO };
